module.exports = __webpack_public_path__ + "img/starsender.327c5d9d.webp";